import React, { useEffect, useRef, useState } from "react";
import { Maximize2, SquareArrowOutUpRight, X } from "lucide-react";
import { twMerge } from "tailwind-merge";

const Preview = ({ src, className, imgClassName, zoomable = false }) => {
    const [previewUrl, setPreviewUrl] = useState(null);
    const [isImage, setIsImage] = useState(true);
    const dialogRef = useRef(null);

    useEffect(() => {
        let objectUrl = null;

        if (src instanceof File) {
            objectUrl = URL.createObjectURL(src);
            setPreviewUrl(objectUrl);
            setIsImage(src.type.startsWith("image/"));
        } else if (typeof src === "string") {
            setPreviewUrl(src);
            setIsImage(true);
        }

        return () => {
            if (objectUrl) URL.revokeObjectURL(objectUrl);
        };
    }, [src]);

    if (!previewUrl) return null;

    const openZoom = (e) => {
        if (!zoomable || !isImage) return;
        e?.stopPropagation?.();
        dialogRef.current?.showModal?.();
    };

    const stop = (e) => e.stopPropagation();

    return (
        <>
            <div className={twMerge("w-full h-full", className)}>
                {isImage ? (
                    <div
                        className={twMerge(
                            "relative w-full h-full",
                            zoomable && "cursor-zoom-in"
                        )}
                        onClick={zoomable ? openZoom : undefined}
                    >
                        <img
                            src={previewUrl}
                            alt="Preview"
                            onError={() => setIsImage(false)}
                            className={twMerge(
                                "max-w-full max-h-screen w-full h-full object-contain object-center",
                                imgClassName
                            )}
                            style={{ maxWidth: "100%", maxHeight: "100vh" }}
                        />
                        {zoomable && (
                            <button
                                type="button"
                                className="btn btn-square btn-sm absolute top-2 right-2 bg-black/70 hover:bg-black text-white border-none"
                                onClick={openZoom}
                                title="Click to enlarge"
                            >
                                <Maximize2 size={16} />
                            </button>
                        )}
                    </div>
                ) : (
                    <div className="relative w-full h-full">
                        <a
                            className="btn btn-square btn-sm absolute top-0 right-0"
                            href={previewUrl}
                            target="_blank"
                            rel="noreferrer"
                        >
                            <SquareArrowOutUpRight size={20} />
                        </a>
                        <iframe
                            title="PDF Preview"
                            src={previewUrl}
                            style={{
                                width: "100%",
                                height: "100vh",
                                border: "none",
                            }}
                        />
                    </div>
                )}
            </div>

            {zoomable && isImage && (
                <dialog ref={dialogRef} className="modal">
                    <div className="modal-box max-w-[95vw] max-h-[95vh] w-auto p-0 bg-transparent shadow-none flex-center">
                        <form method="dialog">
                            <button
                                className="btn btn-sm btn-circle absolute right-2 top-2 z-10 bg-black/70 text-white border-none hover:bg-black"
                                title="Close"
                            >
                                <X size={18} />
                            </button>
                        </form>
                        <a
                            href={previewUrl}
                            target="_blank"
                            rel="noreferrer"
                            className="btn btn-sm btn-circle absolute right-12 top-2 z-10 bg-black/70 text-white border-none hover:bg-black"
                            onClick={stop}
                            title="Open in new tab"
                        >
                            <SquareArrowOutUpRight size={16} />
                        </a>
                        <img
                            src={previewUrl}
                            alt="Receipt full view"
                            className="max-w-[95vw] max-h-[95vh] object-contain bg-white"
                            onClick={stop}
                        />
                    </div>
                    <form method="dialog" className="modal-backdrop">
                        <button>close</button>
                    </form>
                </dialog>
            )}
        </>
    );
};

export default Preview;
